<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card>
        <v-card-title>Tag Color</v-card-title>

        <v-card-text>
            <p>Choose the tag color you would like to use.  The current color is the one in <b>bold</b></p>

            <div
                style="line-height: 55px"
            >
                <v-chip
                    v-for="(item, index) in items"
                    :key="index"
                    :color="item.value"
                    style="margin-right: 5px;"
                    v-on:click="onClickChip(item)"
                >
                    <b
                        v-if="tag != null && tag.color == item.value"
                    >
                        {{item.text}}
                    </b>

                    <span
                        v-else
                    >
                        {{item.text}}
                    </span>

                </v-chip>
            </div>
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                text
                @click="onCancel"
            >
            Cancel
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>
const _ = require('lodash');
export default {

    data() {
        return {
            dialog: false,
            tag: null,
        }
    },

    methods: {

        showDialog(tag)
        {
            this.tag = tag;
            this.dialog = true;
        },

        onOk()
        {
            this.dialog = false;
        },

        onCancel()
        {
            this.dialog = false;
        },

        onClickChip(item)
        {
            let tag = _.cloneDeep(this.tag);
            tag.color = item.value;
            this.dialog = false;
            this.$emit('update-tag',tag);
        },

        randomColor()
        {
            let item = this.items[Math.floor(Math.random()*this.items.length)];
            return item.value;
        },
    },

    computed: {
        items() {
            let ret = [];
            let src = ['red','pink','purple', 'deep-purple', 'indigo','blue','light-blue','cyan','teal','green','light-green','lime','yellow','amber','organge','deep-orange','brown','blue-grey','grey'];

            for ( let i = 0; i < src.length; i++ )
            {
                ret.push(
                    {
                        'value': src[i]+' lighten-4',
                        'text': this.tag == null ? 'placeholder' : this.tag.label,
                    },
                );
            }

            return ret;
        }
    },
}
</script>

<style lang="scss" scoped>
</style>